import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@wix/da-ds/pkg/formControls/lego/InputField';
import EditorUnlink from '@wix/da-ds/pkg/Icons/24x24/EditorUnlink';
import EditorLink from '@wix/da-ds/pkg/Icons/24x24/EditorLink';
import { type Editor } from '@tiptap/core';
import { useKeyDown } from '@wix/da-hooks/pkg/useKeyDown';
import cn from 'classnames';
import { cleanLinkSrc } from '../../../../utils/browser';
import EditorIconButton from '../../../_partials/EditorIconButton';

import s from './ViewLinkMenuContent.scss';

export interface Props {
  editor: Editor;
  href: string | undefined;
  onCancel: () => void;
  onEdit: () => void;
  onRemove: () => void;
}

const ViewLinkMenuContent: FC<Props> = ({
  editor,
  onCancel,
  onRemove,
  onEdit,
  href,
}) => {
  const { t } = useTranslation('editor');
  // If the user presses escape, we should cancel
  useKeyDown({ Escape: onCancel });

  return (
    <div className={cn(s['root'], 'ds-surface-tertiary')}>
      <TextInput
        id="link"
        value={href}
        readOnly
        inputClassname={s['link']}
        onClick={() => {
          if (href?.startsWith('#')) {
            return;
          }
          window.open(cleanLinkSrc(href), '_blank');
        }}
      />
      <EditorIconButton
        featureId="node:linkRemove"
        icon={EditorUnlink}
        tooltipText={t('ext.linkMenu.popover.remove.tooltip')}
        aria-label={t('ext.linkMenu.popover.remove.tooltip')}
        onClick={onRemove}
      />
      <EditorIconButton
        featureId="node:linkEdit"
        icon={EditorLink}
        tooltipText={t('ext.linkMenu.popover.edit.tooltip')}
        aria-label={t('ext.linkMenu.popover.edit.tooltip')}
        onClick={onEdit}
      />
    </div>
  );
};
ViewLinkMenuContent.displayName = 'ViewLinkMenuContent';

export default ViewLinkMenuContent;
